var exports = {
  "kL": "xcc377c0b--81f50f--container",
  "pU": "xcc377c0b--81f50f--iframe",
  "VN": "xcc377c0b--81f50f--close",
  "u1": "xcc377c0b--81f50f--spinner",
};

module.exports = exports;
